import type { Feed } from '@knocklabs/client'
import { createContext } from 'react'

/** Feed scoped to non-archived (active inbox) items. */
export const KnockInboxFeedContext = createContext<Feed | null>(null)

/** Feed scoped to archived (done) items only. */
export const KnockDoneFeedContext = createContext<Feed | null>(null)

/*
 * Alias used by useKnockFeedClient and by InboxDonePage to shadow the
 * inbox context with the done feed for its subtree. Not deprecated —
 * the indirection is intentional.
 */
export const KnockFeedClientContext = KnockInboxFeedContext
